// extracted by mini-css-extract-plugin
export default {"inSyncLabel":"TopologiesInSyncLabel_inSyncLabel__z5STp"};